import { render, staticRenderFns } from "./Bet.vue?vue&type=template&id=a08208a0&scoped=true&"
import script from "./Bet.vue?vue&type=script&lang=js&"
export * from "./Bet.vue?vue&type=script&lang=js&"
import style0 from "./Bet.vue?vue&type=style&index=0&id=a08208a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08208a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a08208a0')) {
      api.createRecord('a08208a0', component.options)
    } else {
      api.reload('a08208a0', component.options)
    }
    module.hot.accept("./Bet.vue?vue&type=template&id=a08208a0&scoped=true&", function () {
      api.rerender('a08208a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/wheel/components/Bet.vue"
export default component.exports